/**
 * 聚合类 ClusterLayer
 */
import React, { Component } from 'react'
import L from 'leaflet'
// 引入 leaflet.markercluster
import "leaflet.markercluster/dist/MarkerCluster.css"
import "leaflet.markercluster/dist/MarkerCluster.Default.css"
import "leaflet.markercluster";
// import icon from "./../source/assets/images/coffee.png";
// import icon from "./source/images/coffee.png";

// L.marker.prototype.icon = L.icon({
//     iconUrl: './source/images/coffee.png',	//设置图标
//     iconSize: [22, 36] //设置图标大小
// });
const myIcon = L.icon({
    iconUrl: './source/images/coffee.png',	//设置图标
    iconSize: [20, 20] //设置图标大小
});
export default L.Layer.extend({
    options: {
    },
    // 类构造函数
    initialize (options) {
        let createMakerCluster = L.markerClusterGroup()
        let marker = L.geoJSON(options.data, {
            style: function (feature) {
                return {color: feature.properties.color};
            },
            pointToLayer: function (geoJsonPoint, latlng) {
                return L.marker(latlng,{
                    icon:myIcon
                });
            },
        }).bindPopup(function (layer) {
            console.log(layer);
            return layer.feature.properties.description;
        });
        createMakerCluster.addLayer(marker)
        options.map.addLayer(createMakerCluster)
        createMakerCluster.on('click',(e)=>{
            console.log(e.layer.feature);
        });



        // const storeLayer = L.markerClusterGroup({
        //     showCoverageOnHover: false,
        //     removeOutsideVisibleBounds: true,
        //     disableClusteringAtZoom: 14,
        //     spiderfyOnMaxZoom: false,
        //     // iconCreateFunction: function (cluster) {
        //     //     return L.divIcon({ html: '<b>' + cluster.getChildCount() + '</b>' });
        //     // },
        //     spiderfyShapePositions: function (count, centerPt) {
        //         var distanceFromCenter = 1135,
        //             markerDistance = 45,
        //             lineLength = markerDistance * (count - 1),
        //             lineStart = centerPt.y - lineLength / 2,
        //             res = [],
        //             i;
    
        //         res.length = count;
    
        //         for (i = count - 1; i >= 0; i--) {
        //             res[i] = new Point(centerPt.x + distanceFromCenter, lineStart + markerDistance * i);
        //         }
        //         return res;
        //     }
        // });
    },
    onAdd(){
        console.log(';;');
    },
    onRemove(){

    }

})